import useDeviceType from "../common/useDeviceType";

const Event = () => {
  const isMobile = useDeviceType();
  return (
    <div
      id="event"
      className="relative w-full h-full bg-[url('../public/images/eventBg.png')] bg-cover lg:bg-fixed bg-right-top lg:bg-center"
    >
      <div
        data-aos="fade-up"
        className="relative w-full h-full px-[calc((100%-var(--container))/2)] pt-14 lg:pt-28 xl:pt-36"
      >
        <img
          src={isMobile ? "/images/eventTxtMo.png" : "/images/eventTxtPc.png"}
          alt="키플레이어 도어락 24시간 긴급출동 이벤트 안내"
        />
      </div>
    </div>
  );
};

export default Event;
